import Ip_Whitelists from './components/Ip_Whitelists';

export default Ip_Whitelists;
